import { useLocation } from 'react-router-dom'
import { Column } from 'src/shared/components/Semantic/all'
import { Separator } from 'src/shared/components/ui/separator'
import { cn } from 'src/shared/components/ui/utils'
import { useOrgsApi } from 'src/api/db/apiOrgs'
import { paths } from 'src/routes/paths'
import { NavItem } from './types'
import { useExpandedItems, useSidebarCollapse } from './hooks'
import {
  SIDEBAR_WIDTH_COLLAPSED,
  SIDEBAR_WIDTH_EXPANDED,
} from './consts'
import { NavItemWithSubItems } from './components/NavItemWithSubItems'
import { NavItemSimple } from './components/NavItemSimple'
import { SidebarHeader } from './components/SidebarHeader'
import { SidebarFooter } from './components/SidebarFooter'

export const SideBar = ({ navItems }: { navItems: NavItem[] }) => {
  const location = useLocation()
  const { organization } = useOrgsApi({})
  const { isCollapsed, toggleCollapsed, expand } = useSidebarCollapse()
  const mainNavItems = navItems.filter(
    (item) => item.href !== paths.myAccount + paths.settings
  )
  const { expandedItems, toggleExpanded } = useExpandedItems(
    mainNavItems,
    location.pathname
  )

  const isLocked = organization?.data?.name === 'Anon'

  return (
    <Column className={cn('py-4 transition-all duration-200', isCollapsed ? 'pl-2' : 'pl-4')}>
      <div className={cn('sidebar-shell h-full rounded-[var(--radius-outer)]', isCollapsed ? 'p-2.5' : 'p-3')}>
        <Column
          className="sidebar-inner h-full transition-all duration-200"
          style={{
            width: isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED,
          }}
        >
          <SidebarHeader
            isCollapsed={isCollapsed}
            onToggleCollapsed={toggleCollapsed}
          />

          <Column className="gap-0.5">
            {mainNavItems.map((item, idx) => {
              if (item.href === 'divider') {
                return <Separator key={idx} className="my-2" />
              }

              const hasSubItems = item.subItems && item.subItems.length > 0

              if (hasSubItems) {
                return (
                  <NavItemWithSubItems
                    key={idx}
                    item={item}
                    isExpanded={expandedItems.has(idx)}
                    onToggle={() => toggleExpanded(idx)}
                    pathname={location.pathname}
                    isCollapsed={isCollapsed}
                    onExpandSidebar={expand}
                  />
                )
              }

              return (
                <NavItemSimple
                  key={idx}
                  item={item}
                  pathname={location.pathname}
                  isLocked={isLocked}
                  isCollapsed={isCollapsed}
                />
              )
            })}
          </Column>

          {!isCollapsed && <SidebarFooter />}
        </Column>
      </div>
    </Column>
  )
}
